import '@/assets/styles/views/solver/solve-question.scss';
import { SolveQuestionProvider } from '@/context/solve-question-context';
import SolveQuestionContent from '@/screens/solver/solve-question/states/question-content.tsx';

const SolveQuestionScreen = () => (
	<SolveQuestionProvider>
		<SolveQuestionContent />
	</SolveQuestionProvider>
);

export default SolveQuestionScreen;
